<template>
    <div>
        <section class="breadcrumb-section decoration_top_section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ page_title }}
                        </li>
                    </ol>
                </nav>
                <!-- <h1 class="main_title" style="text-align: center">
                    <span>{{ page_title }}</span>
                </h1> -->
            </div>
        </section>

        <section class="cmn-section brand_page p-0" v-if="banner_image">
            <div class="decoration-hero">
                <div class="decoration-hero__left">
                    <h1 class="decoration-hero__title">Explore more ways to<br>leave your imprint!</h1>
                </div>
                <div class="decoration-hero__right">
                    <img :src="banner_image" alt="Decoration methods banner" class="default-decoration-banner_image" />
                </div>
            </div>
        </section>
        <section class="cmn-section decoration-section">
            <div class="container">
                <div class="row brand_row decoration-cards-row">
                    <div class="col-sm-6 col-md-6 col-lg-3 decoration-col" v-for="service in paginatedServices" :key="service.id">
                        <div
                            class="decoration-service-card decoration-service-card--clickable"
                            role="link"
                            tabindex="0"
                            @click="goServiceDetail(service.id)"
                            @keydown.enter.prevent="goServiceDetail(service.id)"
                            @keydown.space.prevent="goServiceDetail(service.id)"
                        >
                            <div class="decoration-service-banner-wrap" v-if="service.service_thumbnail || service.service_banner">
                                <img :src="service.service_thumbnail || service.service_banner" :alt="service.service_name || 'Service banner'" class="decoration-service-banner" />
                            </div>
                            <div v-else class="not-uploaded-img">Not uploaded</div>
                            <div class="decoration-service-content">
                                <h2 class="decoration-service-title">{{ service.service_name || "Not uploaded" }}</h2>
                                <p class="decoration-service-desc">
                                    {{ service.service_description || service.description || "Not uploaded" }}
                                </p>
                                <a href="javascript:void(0)" class="decoration-service-readmore" @click.stop.prevent="goServiceDetail(service.id)">Read more</a>
                                <!--
                                  To restore "Shop" CTA on cards:
                                  1) Uncomment this block
                                  2) Keep goHome() method enabled in methods section
                                  3) Keep .decoration-service-btn* styles enabled below
                                <div class="decoration-service-btn-wrap">
                                    <a href="javascript:void(0)" class="decoration-service-btn" @click.stop.prevent="goHome">Shop</a>
                                </div>
                                -->
                            </div>
                        </div>
                    </div>
                </div>
                <nav
                    v-if="totalPages > 1"
                    class="decoration-pagination"
                    aria-label="Decoration services pagination"
                >
                    <button
                        type="button"
                        class="decoration-pagination__prev"
                        :disabled="currentPage <= 1 || isLoader"
                        @click="goToPage(currentPage - 1)"
                    >
                        <span class="decoration-pagination__arrow" aria-hidden="true">←</span>
                        Previous
                    </button>
                    <button
                        v-for="p in visiblePageNumbers"
                        :key="'p-' + p"
                        type="button"
                        class="decoration-pagination__num"
                        :class="{ 'decoration-pagination__num--active': p === currentPage }"
                        :disabled="isLoader"
                        @click="goToPage(p)"
                    >
                        {{ p }}
                    </button>
                    <button
                        type="button"
                        class="decoration-pagination__next"
                        :disabled="currentPage >= totalPages || isLoader"
                        @click="goToPage(currentPage + 1)"
                    >
                        Next
                        <span class="decoration-pagination__arrow" aria-hidden="true">→</span>
                    </button>
                </nav>
            </div>
        </section>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
export default {
    name: "DecorationMethods",
    components: {},
    data() {
        return {
            page_title: "Decoration Methods & Pricing",
            currentPage: 1,
            itemsPerPage: 12,
            decorationServices: [],
            banner_image: `${process.env.VUE_APP_BASE_IMAGE_URL}/common_image/banner.png`,
            isLoader: false
        };
    },
    computed: {
        totalPages() {
            const total = this.decorationServices.length || 0;
            return Math.max(1, Math.ceil(total / this.itemsPerPage));
        },
        paginatedServices() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.decorationServices.slice(start, end);
        },
        visiblePageNumbers() {
            const total = this.totalPages;
            const cur = this.currentPage;
            if (total <= 7) {
                return Array.from({ length: total }, (_, i) => i + 1);
            }
            let start = Math.max(1, cur - 2);
            let end = Math.min(total, cur + 2);
            if (end - start < 4) {
                if (start === 1) end = Math.min(total, start + 4);
                else if (end === total) start = Math.max(1, end - 4);
            }
            const pages = [];
            for (let i = start; i <= end; i++) pages.push(i);
            return pages;
        }
    },
    metaInfo() {
        return {
            title: this.page_title,
            titleTemplate: "%s | Imprintcity",
            meta: [
                {
                    vmid: "title",
                    name: "title",
                    content: "Brands"
                },
                {
                    vmid: "description",
                    name: "description",
                    content: "brands"
                },
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: "brands"
                }
            ]
        };
    },
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        this.loadDecorationServices();
    },
    methods: {
        async loadDecorationServices() {
            this.isLoader = true;
            try {
                const res = await ApiService.query("public/decoration-services", { params: {} });
                this.decorationServices = (res.data && res.data.services) || [];
                this.currentPage = 1;
            } catch (e) {
                this.decorationServices = [];
                this.currentPage = 1;
            } finally {
                this.isLoader = false;
            }
        },
        goToPage(page) {
            const p = Math.max(1, Math.min(page, this.totalPages));
            if (p === this.currentPage) return;
            this.currentPage = p;
            const el = document.querySelector(".decoration-section");
            if (el && el.scrollIntoView) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        },
        goServiceDetail(serviceId) {
            this.$router.push({ name: "DecorationServiceDetail", params: { id: serviceId } });
        },
        // To restore old card "Shop" button, uncomment this method and the template/CSS blocks.
        // goHome() {
        //     this.$router.push({ name: "home" });
        // }
    }
};
</script>
<style scoped>

.decoration-section {
    padding-top: 64px;
    padding-bottom: 44px;
}
.decoration-cards-row {
    margin-left: -6px !important;
    margin-right: -6px !important;
}
.decoration-col {
    padding-left: 6px !important;
    padding-right: 6px !important;
    margin-bottom: 20px;
    display: flex;
}
.decoration-service-card {
    width: 100%;
    min-height: 428px;
    background: #ffffff;
    border: 1px solid #BEBEBE66;
    display: flex;
    flex-direction: column;
}
.decoration-service-card--clickable {
    cursor: pointer;
}
.decoration-service-banner-wrap {
    width: 100%;
    height: 222px;
    max-height: 222px;
    background: #efefef;
}
.decoration-service-banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.not-uploaded-img {
    width: 100%;
    height: 222px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f3f3;
    color: #666;
    font-size: 14px;
}
.decoration-service-content {
    background: #ffffff;
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
    box-shadow: 0px 4px 12px 0px #0000001F;
}
.decoration-service-title {
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
    color: #000000;
    margin: 0 0 12px 0;
}
.decoration-service-desc {
    margin: 0 0 12px 0;
    font-size: 14px;
    line-height: 18px;
    color: #606060;
    min-height: 55px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.decoration-service-readmore {
    display: inline-block;
    margin-top: auto;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    color: #1D6CB5;
}
/*
  To restore old card "Shop" CTA styles, uncomment this block together with
  the commented template block and goHome() method above.
.decoration-service-btn-wrap {
    margin-top: auto;
}
.decoration-service-btn {
    display: block;
    text-align: center;
    border: 1px solid #1D6CB5;
    color: #1D6CB5;
    padding: 12px 8px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    background: #ffffff;
    margin-top: 12px;
    position: relative;
    overflow: hidden;
    transition: color 220ms ease, border-color 220ms ease;
    z-index: 0;
}
.decoration-service-btn::before {
    content: "";
    position: absolute;
    inset: 0;
    background: #1D6CB5;
    transform: translateX(-100%);
    transition: transform 320ms ease;
    z-index: -1;
}
.decoration-service-btn:hover {
    color: #ffffff;
    border-color: #1D6CB5;
}
.decoration-service-btn:hover::before {
    transform: translateX(0);
}
*/
@media (max-width: 991px) {
    .decoration-service-card {
        min-height: 355px;
    }
    .decoration-service-desc,
    .decoration-service-readmore {
        font-size: 18px;
    }
}
@media (max-width: 767px) {
    .decoration-col {
        margin-bottom: 16px;
    }
    .decoration-service-desc,
    .decoration-service-readmore {
        font-size: 16px;
    }
    .decoration-service-btn {
        font-size: 16px;
    }
}
.decoration-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    gap: 10px;
    margin-top: 2rem;
    margin-bottom: 1rem;
}
.decoration-pagination button {
    font-family: inherit;
    font-size: 0.9375rem;
    line-height: 1.4;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.decoration-pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.decoration-pagination__prev {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0.45rem 0.85rem;
    color: #333;
    background: #fff;
    border: 1px solid #d0d0d0;
}
.decoration-pagination__prev:hover:not(:disabled) {
    background: #f8f8f8;
    border-color: #bbb;
}
.decoration-pagination__num {
    min-width: 2.25rem;
    height: 2.25rem;
    padding: 0 0.35rem;
    color: #333;
    background: #fff;
    border: 1px solid #d0d0d0;
}
.decoration-pagination__num:hover:not(:disabled):not(.decoration-pagination__num--active) {
    background: #f8f8f8;
}
.decoration-pagination__num--active {
    color: #fff;
    background: #f2790c;
    border-color: #f2790c;
    cursor: default;
}
.decoration-pagination__next {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0.45rem 0.85rem;
    color: #fff;
    background: #f2790c;
    border: 1px solid #f2790c;
}
.decoration-pagination__next:hover:not(:disabled) {
    background: #d96a0a;
    border-color: #d96a0a;
}
.decoration-pagination__arrow {
    font-size: 0.875em;
}

/* Breadcrumb responsiveness */
@media (max-width: 768px) {
    .breadcrumb-section.decoration_top_section .breadcrumb {
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 0;
    }
    .breadcrumb-section.decoration_top_section .breadcrumb-item,
    .breadcrumb-section.decoration_top_section .breadcrumb-item a {
        font-size: 12px;
        line-height: 16px;
    }
}

/* Pagination responsiveness */
@media (max-width: 768px) {
    .decoration-pagination {
        justify-content: center;
        margin-top: 1.25rem;
    }
    .decoration-pagination__prev,
    .decoration-pagination__next {
        width: 100%;
        justify-content: center;
    }
}

/* Banner (match design screenshot) */
.brand_page {
    width: 100%;
    background: #eef3f7;
}
.decoration-hero {
    width: 100%;
    height: 380px; /* Figma */
    display: flex;
    align-items: stretch;
    gap: 20px;

    justify-content: space-between;
}
.decoration-hero__left {
    position: relative;
    background: #eef3f7;
    display: flex;
    align-items: center;
    padding: 40px 40px 40px 125px;
    flex: 0 0 40%;
    max-width: 40%;
    width: 40%;
}
.decoration-hero__title {
    margin: 0;
    font-weight: 700;
    color: #000000;
    font-size: 48px;
    line-height: 50px;
    letter-spacing: -0.02em;
}

.decoration-hero__right {
    background: #0b0b0b;
    overflow: hidden;
    flex: 1 1 60%;
    width: 60%;
}
.decoration-hero__right .default-decoration-banner_image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    display: block;
}

/* Large tablet / small desktop */
@media (max-width: 1200px) {
    .decoration-hero__left {
        padding: 32px 28px 32px 48px;
    }
    .decoration-hero__title {
        font-size: 36px;
        line-height: 40px;
    }
}

/* Tablet */
@media (max-width: 991px) {
    .decoration-hero {
        height: 320px;
    }
    .decoration-hero__left {
        padding: 24px;
        flex-basis: 45%;
        max-width: 45%;
        width: 45%;
    }
    .decoration-hero__title {
        font-size: 30px;
        line-height: 36px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .decoration-hero {
        height: auto;
        flex-direction: column;
    }
    .decoration-hero__left {
        width: 100%;
        max-width: 100%;
        flex: 0 0 auto;
        padding: 18px 16px;
    }
    .decoration-hero__right {
        width: 100%;
        flex: 0 0 auto;
    }
    .decoration-hero__right .default-decoration-banner_image {
        height: 220px;
    }
    .decoration-hero__title {
        font-size: 28px;
        line-height: 32px;
    }
}

/* Card grid spacing on small screens */
@media (max-width: 576px) {
    .decoration-section {
        padding-top: 40px;
        padding-bottom: 28px;
    }
    .decoration-service-content {
        padding: 18px;
    }
    .decoration-pagination {
        gap: 8px;
    }
}
@media (max-width: 1441px) {
.decoration-hero__left{
    padding-left: 30px;
}
}
</style>
